module.exports = __webpack_public_path__ + "static/media/wine.3615efe7.png";